import React from 'react';
import{Container} from '@material-ui/core';


import { BrowserRouter, Route, Routes,Navigate } from 'react-router-dom';

import Navbar from './components/Navbar/Navbar';
import Home from './components/Home/Home';
import Auth from './components/Auth/Auth';
import useStyles from './styles';
import PostDetails from './components/PostDetails/PostDetails';
const App = () => {

const classes = useStyles();  

    const user = JSON.parse(localStorage.getItem('profile'));
  return (
    <BrowserRouter>
    <Container className={classes.mainContainer} maxwidth='xl'>
      <Navbar/>
    <Routes>
      <Route path='/' exact element={<Navigate to='/posts'/>}/>
      <Route path='/posts' exact element={<Home/>}/>
      <Route path='/posts/search' exact element={<Home/>}/>
      <Route path='/posts/:id'  element={<PostDetails/>}/>
      <Route path='/auth' exact element={!user? <Auth />:<Navigate to='/posts'/>}/>

    </Routes>
    
    

    </Container>
    </BrowserRouter>
    
  )
}

export default App